;(function ($) {
    $.fn.naturataSubmenuToggle = function () {
        return $(this).each(function () {
            var container = $(this);
            var body = $('body');
            var clonedSubmenu = null;
            var itemsWithSubmenu = container.find('li.has-submenu');
            itemsWithSubmenu.children('a').on('click', function(e) {
                e.preventDefault();
                var parentItem = $(this).parent();
				parentItem.siblings('.has-submenu').not(parentItem).removeClass('open');
				parentItem.toggleClass('open');

				if(parentItem.hasClass('open')) {
				    body.addClass('submenu-visible');
                } else {
					body.removeClass('submenu-visible');
                }

                container.children().toggleClass('hidden');
                clonedSubmenu = $(this).parent().find('.submenu').clone().appendTo(container);
				$('body').removeClass('searchbar-visible');
            });
            container.on('click', '[data-naturata-close-submenu]', function() {
                clonedSubmenu.remove();
                clonedSubmenu = null;
                container.children().removeClass('hidden');
            });
        });
    };
    $(function(){
        $('nav.main').naturataSubmenuToggle();
    });
})(jQuery);
